/* eslint-disable camelcase */

const getDeviceOS = () => 'web'

const getDeviceLocale = () => navigator.language.slice(0, 2)

const getDeviceScreenHeight = () => window.innerHeight

const getDeviceScreenWidth = () => window.innerWidth

const getHardwareAccelerated = () => true

export const generatePollfishParams = () => {
  const device_os = getDeviceOS()
  const device_locale = getDeviceLocale()
  const device_screen_height = getDeviceScreenHeight()
  const device_screen_width = getDeviceScreenWidth()
  const hardware_accelerated = getHardwareAccelerated()

  const pollfishParams = {
    device_os,
    device_locale,
    device_screen_height,
    device_screen_width,
    hardware_accelerated,
  }

  const filteredPollfishParams = Object.entries(pollfishParams).reduce(
    (acc, [key, value]) => (value === null || value === undefined || value === '' ? acc : { ...acc, [key]: value }),
    {},
  )

  return filteredPollfishParams
}
